<template>
  <main>
    <div class="row">
      <div class="col-md-12">
        <TopTemplate>
          <template #left-element>
            <h3>{{ $t("title.editStudent") }}</h3>
          </template>

          <template #right-element>
            <a @click="$router.go(-1)" class="btn btn-outline-primary button" :disabled="loading">
              <i class="arrow left" />
              {{ $t("button.retour") }}
            </a>
          </template>
        </TopTemplate>
        <div v-if="is_created" class="alert alert-success" role="alert">
          L'élève
          <router-link style="color: black; font-weight: 600" :to="{name: 'DetailStudent', params: {id: student.id}}">
            {{ student.last_name }} {{ student.first_name }}
          </router-link>
          a été modifié avec succès !
        </div>
        <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
          <div class="spinner-border text-info" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <form v-else class="add-student" novalidate @submit.prevent="onSubmitCreateStudent">
          <div class="general-info">
            <div class="accordSid" @click="toggleAccInfo()">
              <h3>{{ $t("title.infoGeneral") }}</h3>
              <div class="icons-wrapper">
                <i v-if="show1" class="icon-Minus color-green" />
                <i v-else class="icon-Add color-green" />
              </div>
            </div>

            <div v-if="show1" class="panel">
              <div class="row align-items-center">
                <div class="col-xl-10 col-md-9">
                  <div class="row">
                    <div :class="existStudent ? 'col-md-4' : 'col-md-6'">
                      <div class="simple-input">
                        <label class="label">
                          {{ $t("eleve.form.firstName") }}
                          <sup>*</sup>
                        </label>
                        <div>
                          <input v-model="student.first_name" type="text" class="form-control" :class="{'is-invalid': v$.student.first_name.$error}" />
                          <span v-if="v$.student.first_name.$error" class="invalid-feedback">
                            {{ v$.student.first_name.$errors[0].$message }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div :class="existStudent ? 'col-md-4' : 'col-md-6'">
                      <div class="simple-input">
                        <label class="label">
                          {{ $t("eleve.form.lastName") }}
                          <sup>*</sup>
                        </label>
                        <div>
                          <input v-model="student.last_name" type="text" class="form-control" :class="{'is-invalid': v$.student.last_name.$error}" />
                          <span v-if="v$.student.last_name.$error" class="invalid-feedback">
                            {{ v$.student.last_name.$errors[0].$message }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div v-if="existStudent" class="col-md-4">
                      <div class="simple-input">
                        <label class="label">
                          {{ $t("eleve.form.phone") }}
                        </label>
                        <div>
                          <input v-model="student.phone_number" type="text" class="form-control" @input="formatPhoneNumber(student.phone_number, 3)" />
                          <span class="invalid-phone" v-if="phoneExist">{{ $t("msg.phoneExist") }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-if="existStudent" class="col-md-3">
                      <div class="simple-input">
                        <label class="label">
                          {{ $t("eleve.form.email") }}
                        </label>
                        <div>
                          <input v-model="student.email" type="text" class="form-control" />
                        </div>
                      </div>
                    </div>
                    <div :class="existStudent ? 'col-md-3' : 'col-md-6'">
                      <div class="simple-input">
                        <label class="label">{{ $t("eleve.form.dateNaissance") }}</label>
                        <div class="input-date">
                          <Datepicker v-model="student.birthday" autoApply :enable-time-picker="false" locale="fr" :format="format_date_v1" :max-date="maxDate" />
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="simple-input">
                            <label class="label">{{ $t("eleve.form.lieuNaissance") }}</label>
                            <div>
                              <input v-model="student.place_of_birth" type="text" />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="simple-input-gender">
                            <label class="label">{{ $t("eleve.form.genre") }}</label>
                            <div>
                              <v-select v-model="student.student_gender" :searchable="true" :options="gender" label="name" :reduce="(option) => option.id" class="form-control">
                                <template #no-options="{search, searching, loading}">
                                  {{ $t("info.noResult") }}
                                </template>
                              </v-select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-md-3 avatar_photo">
                  <div class="avatar">
                    <div class="avatar_edit">
                      <label for="studentPhoto">
                        <i class="ri-edit-2-line" />
                      </label>
                    </div>
                    <input id="studentPhoto" ref="uploadstudentPhoto" name="photo" type="file" class="custom-file-input" accept=".jpeg, .jpg, .png" @change="onImageChange" />
                    <label v-if="student.photo" for="studentPhoto">
                      <img :src="student.photo" :class="{'d-block': student.photo}" class="img-thumbnail img-fluid" />
                    </label>
                    <label v-else for="studentPhoto">
                      <img src="/images/avatar_student.png" alt="avatar" class="avator img-fluid" />
                    </label>
                  </div>
                  <span class="indice">{{ $t("info.formatPhoto") }}</span>
                  <span class="indice">{{ $t("info.sizeImage") }}</span>
                  <span v-if="errorDocSize" class="indice errorSizeDoc">{{ $t("error.errorTailleMsg") }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="general-info duplicator">
            <div class="accordSid" @click="toggleAccSco()">
              <h3>{{ $t("title.scolaire") }}</h3>
              <div class="icons-wrapper">
                <i v-if="show5" class="icon-Minus color-green" />
                <i v-else class="icon-Add color-green" />
              </div>
            </div>
            <div v-if="show5" class="panel">
              <div v-for="(item, index) in student.scolarities" :key="index" class="row">
                <div class="simple-input simple-select simple-select-disab col-md-3 col-6">
                  <label class="label">{{ $t("eleve.form.anneeScolaire") }}<sup>*</sup></label>
                  <v-select
                    v-model="item.school_year"
                    :options="computedScolarityYear(item.school_year)"
                    @update:modelValue="resetFields('school_year', index)"
                    label="school_year"
                    :searchable="false"
                    :reduce="(option) => option.id"
                    class="form-control"
                    :class="{'is-invalid': v$.student.scolarities.$dirty && v$.student.scolarities.$each.$response.$data[index].school_year.$error}"
                    :deselectFromDropdown="true"
                    :loading="false"
                  >
                    <template #no-options="{}">{{ $t("error.noResult") }} </template>
                  </v-select>
                  <span v-if="v$.student.scolarities.$dirty && v$.student.scolarities.$each.$response.$data[index].school_year.$error" class="invalid-feedback">{{
                    $t("validation.required")
                  }}</span>
                </div>
                <div class="simple-input simple-select simple-select-disab col-md-3 col-6">
                  <label class="label">{{ $t("eleve.form.niveau") }}<sup>*</sup></label>
                  <v-select
                    v-model="item.class_type_id"
                    :options="computedOptionsTypes(item.school_year)"
                    @update:modelValue="resetFields('class_type_id', index)"
                    label="name"
                    :searchable="false"
                    :reduce="(option) => option.id"
                    class="form-control dis"
                    :class="{'is-invalid': v$.student.scolarities.$dirty && v$.student.scolarities.$each.$response.$data[index].class_type_id.$error}"
                  >
                    <template #no-options="{search, searching, loading}">
                      <template v-if="search || searching || loading">
                        {{ $t("info.noResult") }}
                      </template>
                      <template v-else> {{ $t("info.noResult") }} </template>
                    </template>
                  </v-select>
                  <span v-if="v$.student.scolarities.$dirty && v$.student.scolarities.$each.$response.$data[index].class_type_id.$error" class="invalid-feedback">{{
                    $t("validation.required")
                  }}</span>
                </div>
                <div class="simple-input simple-select simple-select-disab col-md-3 col-6">
                  <label class="label">{{ $t("eleve.form.class") }}</label>
                  <v-select
                    v-model="item.class_school_id"
                    :options="computedOptionsScolarity(item.school_year, item.class_type_id)"
                    label="name"
                    :searchable="false"
                    :reduce="(option) => option.id"
                    class="form-control dis"
                    :disabled="!item.class_type_id"
                  >
                    <template #no-options="{search, searching, loading}">
                      <template v-if="search || searching || loading">
                        {{ $t("info.noResult") }}
                      </template>
                      <template v-else> {{ $t("info.noResult") }} </template>
                    </template>
                  </v-select>
                </div>
                <div class="simple-input last-input-modif col-md-3 col-6">
                  <label class="label">{{ $t("eleve.form.school") }}</label>
                  <div>
                    <input v-model="item.school_name" type="text" />
                  </div>
                  <div class="buttons-wrapper btn-delete">
                    <i v-if="student.scolarities.length > 1" class="icon-trash" @click="removeItem(index)" />
                  </div>
                </div>
                <div v-if="index === student.scolarities.length - 1" class="col-md-12 btn-add">
                  <button :disabled="student.scolarities && student.scolarities.length >= getScolarityFilter.school_year.length" class="btn button btn-primary" @click="addMore()">
                    <i class="icon-Add" /> {{ $t("button.add") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="general-info">
            <div class="accordSid" @click="toggleAccNiv()">
              <h3>{{ $t("title.niveauScolaire") }}</h3>
              <div class="icons-wrapper">
                <i v-if="show2" class="icon-Minus color-green" />
                <i v-else class="icon-Add color-green" />
              </div>
            </div>

            <div v-if="show2" class="panel">
              <div class="row">
                <div class="col-md-6">
                  <div class="simple-input simple-select">
                    <label class="label">
                      {{ $t("eleve.form.niveau") }}
                      <sup>*</sup>
                    </label>
                    <v-select
                      v-model="student.level_id"
                      :options="levels"
                      label="name"
                      :searchable="true"
                      :reduce="(option) => option.id"
                      :class="{'is-invalid': v$.student.level_id.$error}"
                      class="form-control"
                      @update:modelValue="ChangeLevel($event, true), ChangeDis()"
                    >
                      <template #no-options="{search, searching, loading}">
                        {{ $t("info.noResult") }}
                      </template>
                    </v-select>
                    <span v-if="v$.student.level_id.$error" class="invalid-feedback">{{ v$.student.level_id.$errors[0].$message }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="simple-input simple-select">
                    <label class="label">{{ $t("eleve.form.class") }}</label>
                    <v-select
                      v-model="student.class_school_id"
                      :searchable="true"
                      :options="classes"
                      label="name"
                      :reduce="(option) => option.id"
                      class="form-control"
                      :disabled="!student.level_id"
                    >
                      <template #no-options="{search, searching, loading}">
                        {{ $t("info.noResult") }}
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div class="general-info">
            <div class="accordSid" @click="toggleAccPar()">
              <h3>{{ $t("title.parents") }}</h3>
              <div class="icons-wrapper">
                <i v-if="show3" class="icon-Minus color-green" />
                <i v-else class="icon-Add color-green" />
              </div>
            </div>

            <div v-if="show3" class="panel">
              <span class="label-parent">{{ $t("eleve.form.father") }}</span>
              <div class="spec-inputs">
                <div class="row">
                  <div class="col-md-4">
                    <div class="simple-input">
                      <label class="label">{{ $t("eleve.form.firstName") }}</label>
                      <div>
                        <input v-model="student.parents[1].first_name" type="text" class="form-control" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="simple-input">
                      <label class="label">{{ $t("eleve.form.lastName") }}</label>
                      <div>
                        <input v-model="student.parents[1].last_name" type="text" class="form-control" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="simple-input">
                      <label class="label">{{ $t("eleve.form.email") }}</label>
                      <div class="inputcontainer" :class="v$.student.parents[1].email.$error || showerremailmere ? 'loader-style' : ''">
                        <input
                          v-model="student.parents[1].email"
                          type="email"
                          class="form-control"
                          :class="{'is-invalid': v$.student.parents[1].email.$error || showerremailmere}"
                          @blur="getDataPere()"
                          @input="emailMessage('emailmere')"
                        />
                        <span v-if="v$.student.parents[1].email.$error" class="invalid-feedback">{{ v$.student.parents[1].email.email.$message }}</span>
                        <span v-if="showerremailmere" class="invalid-feedback">{{ $t("error.infoEmailpere") }}</span>
                        <div v-if="loaderPere" class="icon-container">
                          <i class="loader" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="simple-input">
                      <label class="label">{{ $t("eleve.form.fonction") }}</label>
                      <div>
                        <input v-model="student.parents[1].function" type="text" class="form-control" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="simple-input simple-select">
                      <label class="label">{{ $t("eleve.form.lieu") }}</label>
                      <input v-model="student.parents[1].lieu_travail" type="text" class="form-control" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="simple-input">
                      <label class="label">{{ $t("eleve.form.address") }}</label>
                      <div>
                        <input v-model="student.parents[1].addresse" type="text" class="form-control" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="simple-input simple-select">
                      <label class="label">{{ $t("eleve.form.ville") }}</label>
                      <input v-model="student.parents[1].ville" type="text" class="form-control" />
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="simple-input simple-select">
                      <label class="label">{{ $t("eleve.form.pays") }}</label>
                      <input v-model="student.parents[1].pays" type="text" class="form-control" />
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="simple-input">
                      <label class="label">{{ $t("eleve.form.code") }}</label>
                      <div>
                        <input
                          v-model="student.parents[1].code_postale"
                          type="tel"
                          maxlength="4"
                          minlength="4"
                          class="form-control"
                          :class="{'is-invalid': v$.student.parents[1].code_postale.$error}"
                        />
                        <span v-if="v$.student.parents[1].code_postale.$error" class="invalid-feedback">{{ v$.student.parents[1].code_postale.numeric.$message }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="simple-input">
                      <label class="label">{{ $t("eleve.form.phone") }}</label>
                      <div>
                        <input
                          v-model="student.parents[1].phone"
                          oninput="this.value = this.value.replace(/[^0-9+]/g, '').replace(/(\..*)\+/g, '$1');"
                          type="tel"
                          class="form-control tel"
                          :class="{
                            'is-invalid':
                              (!validNumbersFather.valid && isValidate) || !validNumbersFather.unique || !requiredNumbersFather.required || v$.student.parents[1].phone.$error,
                          }"
                          @blur="getDataPereByPhone(), checkParentPhoneNumbers()"
                          @input="formatPhoneNumber(student.parents[1].phone, 1)"
                        />
                        <span v-if="v$.student.parents[1].phone.$error" class="invalid-feedback">
                          {{ $t("validation.required") }}
                        </span>

                        <span v-if="!validNumbersFather.unique" class="invalid-feedback">{{ $t("error.infoPhonePere") }}</span>
                        <span v-if="!validNumbersFather.valid && isValidate" class="invalid-feedback">{{ $t("validation.isPhone") }}</span>
                        <span v-if="!requiredNumbersFather.required" class="invalid-feedback">{{ $t("error.requiredPhone") }}</span>
                        <div v-if="loaderPerePhone" class="icon-container">
                          <i class="loader" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span class="label-parent">{{ $t("eleve.form.mother") }}</span>
              <div class="spec-inputs">
                <div class="row">
                  <div class="col-md-4">
                    <div class="simple-input">
                      <label class="label">{{ $t("eleve.form.firstName") }}</label>
                      <div>
                        <input v-model="student.parents[0].first_name" type="text" class="form-control" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="simple-input">
                      <label class="label">{{ $t("eleve.form.lastName") }}</label>
                      <div>
                        <input v-model="student.parents[0].last_name" type="text" class="form-control" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="simple-input">
                      <label class="label">{{ $t("eleve.form.email") }}</label>
                      <div class="inputcontainer" :class="v$.student.parents[0].email.$error || showerremailpere ? 'loader-style' : ''">
                        <input
                          v-model="student.parents[0].email"
                          type="email"
                          class="form-control"
                          :class="{'is-invalid': v$.student.parents[0].email.$error || showerremailpere}"
                          @blur="getDataMere()"
                          @input="emailMessage('emailpere')"
                        />
                        <div v-if="loaderMere" class="icon-container">
                          <i class="loader" />
                        </div>
                        <span v-if="v$.student.parents[0].email.$error" class="invalid-feedback">{{ v$.student.parents[0].email.email.$message }}</span>
                        <span v-if="showerremailpere" class="invalid-feedback">{{ $t("error.infoEmailmere") }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="simple-input">
                      <label class="label">{{ $t("eleve.form.fonction") }}</label>
                      <div>
                        <input v-model="student.parents[0].function" type="text" class="form-control" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="simple-input simple-select">
                      <label class="label">{{ $t("eleve.form.lieu") }}</label>
                      <input v-model="student.parents[0].lieu_travail" type="text" class="form-control" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="simple-input">
                      <label class="label">{{ $t("eleve.form.phone") }}</label>
                      <div>
                        <input
                          v-model="student.parents[0].phone"
                          type="text"
                          class="form-control"
                          :class="{
                            'is-invalid': (!errorMessage && isValidate) || !validNumbersMother.unique || !requiredNumbersMother.required || v$.student.parents[0].phone.$error,
                          }"
                          @blur="getDataMereByPhone(), checkParentPhoneNumbers()"
                          @input=""
                        />
                        <div v-if="errorMessage" class="invalid-feedback">{{ $t("error.infoPhoneMere") }}</div>

                        <span v-if="v$.student.parents[0].phone.$error" class="invalid-feedback">
                          {{ $t("validation.required") }}
                        </span>

                        <span v-if="!validNumbersMother.valid && isValidate" class="invalid-feedback">{{ $t("validation.isPhone") }}</span>
                        <span v-if="!validNumbersMother.unique" class="invalid-feedback">{{ $t("error.infoPhoneMere") }}</span>
                        <span v-if="!requiredNumbersMother.required" class="text-danger">{{ $t("error.requiredPhone") }}</span>
                        <div v-if="loaderMerePhone" class="icon-container">
                          <i class="loader" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 spec-inputs-check">
                    <div class="simple-input-checkbox">
                      <label class="container-checkbox">
                        <input v-model="completeAdresseMother" type="checkbox" />
                        <span class="checkmark" />
                      </label>
                      <label class="label">{{ $t("eleve.form.preciserAdd") }}</label>
                    </div>
                  </div>
                  <div v-if="completeAdresseMother" class="col-md-6">
                    <div class="simple-input">
                      <label class="label">{{ $t("eleve.form.address") }}</label>
                      <div>
                        <input v-model="student.parents[0].addresse" type="text" />
                      </div>
                    </div>
                  </div>

                  <div v-if="completeAdresseMother" class="col-md-6 simple-input simple-select">
                    <label class="label">{{ $t("eleve.form.ville") }}</label>
                    <input v-model="student.parents[0].ville" type="text" class="form-control" />
                  </div>
                  <div v-if="completeAdresseMother" class="col-md-6">
                    <div class="simple-input">
                      <label class="label">{{ $t("eleve.form.code") }}</label>
                      <div>
                        <input
                          v-model="student.parents[0].code_postale"
                          oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\+/g, '$1');"
                          type="tel"
                          maxlength="4"
                          minlength="4"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div v-if="completeAdresseMother" class="col-md-6">
                    <div class="simple-input simple-select">
                      <label class="label">{{ $t("eleve.form.pays") }}</label>
                      <input v-model="student.parents[0].pays" type="text" class="form-control" />
                    </div>
                  </div>
                </div>
              </div>

              <button v-if="!tuteurAdd" class="btn button btn-primary btn-add" :disabled="loading" type="button" @click="addTuteur()">
                <i class="icon-Add" />
                {{ $t("button.addTuteur") }}
              </button>
              <span v-if="tuteurAdd" class="label-parent">{{ $t("eleve.form.tuteur") }}</span>
              <div v-if="tuteurAdd" class="spec-inputs">
                <div class="row">
                  <div class="col-md-4">
                    <div class="simple-input">
                      <label class="label">{{ $t("eleve.form.firstName") }}</label>
                      <div>
                        <input v-model="student.parents_tuteur[0].first_name" type="text" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="simple-input">
                      <label class="label">{{ $t("eleve.form.lastName") }}</label>
                      <div>
                        <input v-model="student.parents_tuteur[0].last_name" type="text" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="simple-input">
                      <label class="label">{{ $t("eleve.form.email") }}</label>
                      <div class="inputcontainer" :class="v$.student.parents_tuteur[0].email.$error ? 'loader-style' : ''">
                        <input
                          v-model="student.parents_tuteur[0].email"
                          type="email"
                          class="form-control"
                          :class="{'is-invalid': v$.student.parents_tuteur[0].email.$error}"
                          @blur="getDataTuteur()"
                        />
                        <span v-if="v$.student.parents_tuteur[0].email.$error" class="invalid-feedback">{{ v$.student.parents_tuteur[0].email.email.$message }}</span>
                        <div v-if="loaderTuteur" class="icon-container">
                          <i class="loader" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="simple-input">
                      <label class="label">{{ $t("eleve.form.relation") }}</label>
                      <div>
                        <input v-model="student.parents_tuteur[0].relation_eleve" type="text" />
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="simple-input simple-select">
                      <label class="label">{{ $t("eleve.form.phone") }}</label>
                      <div>
                        <input
                          v-model="student.parents_tuteur[0].phone"
                          type="tel"
                          class="form-control"
                          :class="{
                            'is-invalid':
                              (!validNumbersTuteur.valid && isValidate) ||
                              !validNumbersTuteur.unique ||
                              !requiredNumbersTuteur.required ||
                              v$.student.parents_tuteur[0].phone.$error,
                          }"
                          @blur="getDataTuteurByPhone()"
                          @input="formatPhoneNumber(student.parents_tuteur[0].phone, 2)"
                        />
                        <span v-if="v$.student.parents_tuteur[0].phone.$error" class="invalid-feedback">
                          {{ $t("validation.required") }}
                        </span>

                        <span v-if="!validNumbersTuteur.valid && isValidate" class="invalid-feedback">{{ $t("validation.isPhone") }}</span>
                        <span v-if="!validNumbersTuteur.unique" class="text-danger">{{ $t("error.infoPhoneParent") }}</span>
                        <span v-if="!requiredNumbersTuteur.required" class="text-danger">{{ $t("error.requiredPhone") }}</span>
                        <div v-if="loaderTuteurPhone" class="icon-container">
                          <i class="loader" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 spec-inputs-check">
                    <div class="simple-input-checkbox">
                      <label class="container-checkbox">
                        <input v-model="completeAdresseTuteur" type="checkbox" />
                        <span class="checkmark" />
                      </label>
                      <label class="label">{{ $t("eleve.form.preciserAdd") }}</label>
                    </div>
                  </div>
                  <div v-if="completeAdresseTuteur" class="col-md-6">
                    <div class="simple-input">
                      <label class="label">{{ $t("eleve.form.address") }}</label>
                      <div>
                        <input v-model="student.parents_tuteur[0].addresse" type="text" />
                      </div>
                    </div>
                  </div>

                  <div v-if="completeAdresseTuteur" class="col-md-6 simple-input simple-select">
                    <label class="label">{{ $t("eleve.form.ville") }}</label>
                    <input v-model="student.parents_tuteur[0].ville" type="text" class="form-control" />
                  </div>
                  <div v-if="completeAdresseTuteur" class="col-md-6">
                    <div class="simple-input">
                      <label class="label">{{ $t("eleve.form.code") }}</label>
                      <div>
                        <input
                          v-model="student.parents_tuteur[0].code_postale"
                          oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\+/g, '$1');"
                          type="tel"
                          maxlength="4"
                          minlength="4"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div v-if="completeAdresseTuteur" class="col-md-6">
                    <div class="simple-input simple-select">
                      <label class="label">{{ $t("eleve.form.pays") }}</label>
                      <input v-model="student.parents_tuteur[0].pays" type="text" class="form-control" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="general-info">
            <div class="accordSid" @click="toggleAccSit()">
              <h3>{{ $t("title.situatuinFamille") }}</h3>
              <div class="icons-wrapper">
                <i v-if="show4" class="icon-Minus color-green" />
                <i v-else class="icon-Add color-green" />
              </div>
            </div>

            <div v-if="show4" class="panel">
              <div class="spec-inputs-check">
                <h4>{{ $t("eleve.form.situationEnfant") }}</h4>
                <div class="row">
                  <div v-for="situationStud in studentSituation" :key="'student-sit-' + situationStud.id" class="col-md-3">
                    <div class="simple-input-checkbox">
                      <label class="container-checkbox">
                        <input :id="'situation-' + situationStud.id" v-model="student.student_situation_id" type="radio" :value="situationStud.id" />
                        <span class="checkmark checkmark-radio" />
                      </label>
                      <label class="label" :for="'situation-' + situationStud.id">
                        {{ situationStud.situation }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="spec-inputs-check">
                <h4>{{ $t("eleve.form.situationParents") }}</h4>
                <div class="row">
                  <div v-for="situationParent in parentSituation" :key="'student-parent-' + situationParent.id" class="col-md-3">
                    <div class="simple-input-checkbox">
                      <label class="container-checkbox">
                        <input :id="'situ-' + situationParent.id" v-model="selectedSituation" type="checkbox" :value="situationParent.id" />
                        <!-- <input
                            type="radio"
                            v-model="student.parent_situation_id"
                            :value="situationParent.id"
                            :id="'situ-' +situationParent.id"
                          > -->
                        <span class="checkmark" />
                      </label>
                      <label class="label" :for="'situ-' + situationParent.id">
                        {{ situationParent.situation }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="general-info duplicator">
            <div class="accordSid" @click="toggleAccEx()">
              <h3>{{ $t("title.activites") }}</h3>
              <div class="icons-wrapper">
                <i v-if="show6" class="icon-Minus color-green" />
                <i v-else class="icon-Add color-green" />
              </div>
            </div>

            <div v-if="show6" class="panel">
              <div v-for="(item, index) in student.activities" :key="index" class="row align-items-center duplicator__ex">
                <div class="col-md-5">
                  <div class="simple-input simple-select">
                    <label class="label">{{ $t("eleve.form.activite") }}</label>
                    <v-select v-model="student.activities[index].activity" :searchable="true" :options="activities" label="name" :reduce="(option) => option" class="form-control">
                      <template #no-options="{search, searching, loading}">
                        <div v-if="!loading" class="card text-center d-block">
                          {{ $t("error.noResult") }}
                        </div>
                        <div v-else class="card text-center d-block">
                          <div class="spinner-border text-info" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="simple-input last-input-modif">
                    <label class="label">{{ $t("eleve.form.preciser") }}</label>
                    <div>
                      <input v-model="student.activities[index].description" maxlength="50" type="text" />
                    </div>
                    <div class="buttons-wrapper btn-add">
                      <i v-if="student.activities.length > 1" class="icon-trash" @click="removeItemEx(index)" />
                    </div>
                  </div>
                </div>

                <div v-if="index === student.activities.length - 1" class="col-md-12 btn-add">
                  <button class="btn button btn-primary" @click="addMoreEx()"><i class="icon-Add" /> {{ $t("button.add") }}</button>
                </div>
              </div>
            </div>
          </div>
          <!-- services-->
          <div v-if="existPay" class="general-info duplicator">
            <div class="accordSid" @click="toggleAccSer()">
              <h3>{{ $t("title.services") }}</h3>
              <div class="icons-wrapper">
                <i v-if="show7" class="icon-Minus color-green" />
                <i v-else class="icon-Add color-green" />
              </div>
            </div>
            <div v-if="show7 && !loadingService" class="panel">
              <div v-for="(item, index) in student.services" :key="index" class="row align-items-center duplicator__ex">
                <div class="col-md-3">
                  <div class="simple-input simple-select">
                    <label class="label">{{ $t("eleve.form.nameService") }}</label>
                    <v-select v-model="student.services[index].service" :searchable="true" :options="services" label="name" :reduce="(option) => option" class="form-control">
                      <template #no-options="{search, searching, loading}">
                        <div v-if="!loading" class="card text-center d-block">
                          {{ $t("error.noResult") }}
                        </div>
                        <div v-else class="card text-center d-block">
                          <div class="spinner-border text-info" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="simple-input">
                    <div class="row">
                      <div class="col-md-6">
                        <label class="label" style="margin-top: 55px">{{ $t("eleve.form.typediscount") }}</label>
                      </div>
                      <div class="col-md-6">
                        <div class="spec-inputs-check" style="margin-top: 55px; margin-bottom: 0">
                          <div class="row">
                            <div v-for="type in discount_type" :key="type.id" class="col-md-5">
                              <div class="simple-input-checkbox">
                                <label class="container-checkbox">
                                  <input
                                    :id="type.id"
                                    v-model="student.services[index].discount_type"
                                    type="radio"
                                    @change="changetypeDiscount(student.services[index])"
                                    :value="type.id"
                                  />
                                  <span class="checkmark checkmark-radio" />
                                </label>
                                <label class="label" style="margin-left: 30px">{{ type.name }}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="simple-input last-input-modif">
                    <div class="row">
                      <div class="col-md-5">
                        <label class="label label-center">{{ $t("eleve.form.valeur") }}</label>
                      </div>
                      <div class="col-md-7 bloc-data-service">
                        <input
                          v-model="student.services[index].discount_value"
                          class="form-control"
                          @input="validateDiscount(student.services[index])"
                          :disabled="disabledamountValue(student.services, index)"
                          @keydown="preventNegative($event)"
                        />
                        <span v-if="student.services[index].errorNumber" class="invalid-feedback invalid-amount" style="position: absolute; display: block">{{
                          $t("error.champChiffre")
                        }}</span>
                        <span v-if="student.services[index].error" class="invalid-feedback invalid-amount" style="position: absolute; display: block">
                          Le montant doit être inférieur à
                          {{ student.services[index].maxAmount }} dt
                        </span>
                        <span v-if="student.services[index].errorPercent" class="invalid-feedback invalid-amount" style="position: absolute; display: block"
                          >{{ $t("error.errorPercent") }}
                        </span>
                      </div>
                    </div>
                    <div class="buttons-wrapper btn-add btn-service">
                      <i v-if="student.services.length > 1" class="icon-trash" @click="removeItemSer(student.services[index], index)" />
                    </div>
                  </div>
                </div>

                <div v-if="index === student.services.length - 1" class="col-md-12 btn-add">
                  <button
                    :disabled="(student.services && student.services.length >= allService.length) || disabledAdd(student.services)"
                    class="btn button btn-primary"
                    @click="addMoreSer()"
                  >
                    <i class="icon-Add" /> {{ $t("button.add") }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="general-info compo-info">
            <div class="accordSid" @click="toggleAccComp()">
              <h3>{{ $t("title.commentaires") }}</h3>
              <div class="icons-wrapper">
                <i v-if="showcompo" class="icon-Minus color-green" />
                <i v-else class="icon-Add color-green" />
              </div>
            </div>
            <div v-if="showcompo" class="panel">
              <div class="row d-flex justify-content-between align-items-center switch-wrapper">
                <div class="col-md-10">
                  <label class="label">{{ $t("eleve.form.description") }}</label>
                </div>
                <div class="col-md-2 bloc-arabe">
                  <div class="d-flex align-items-center">
                    <span class="left-lang" :class="{colorsupp: dir == 'ltr'}">{{ $t("common.latin") }}</span>
                    <div class="switch-button">
                      <label class="switch">
                        <input v-model="checked" type="checkbox" @change="changeLanguage()" />
                        <span class="slider round" :class="[dir == 'rtl' ? 'rightclass' : '']" />
                      </label>
                    </div>
                    <span class="right-lang" :class="{colorsupp: dir == 'rtl'}">{{ $t("common.arabe") }}</span>
                  </div>
                </div>
                <div class="col-md-12">
                  <textarea v-model="student.compoFiled" maxlength="500" class="text-compo" :dir="dir" />
                  <label class="indice">{{ $t("info.sizeText") }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 buttons">
            <div class="button-right d-flex justify-content-end mb-4">
              <button type="submit" class="btn button btn-primary" :disabled="loading">
                <i class="icon-Check" />
                {{ $t("button.envoi") }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import vSelect from "vue-select";
import Form from "../../core/Form";
import useValidate from "@vuelidate/core";
import {required, requiredIf, helpers, email, numeric} from "@vuelidate/validators";
import LevelsService from "../../services/levels.service";
import ActivitiesService from "../../services/activities.service";
import SituationsService from "../../services/situations.service";
import StudentService from "../../services/student.service";
import ServicesService from "../../services/services.service";
import moment from "moment";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import {parsePhoneNumberFromString, isValidNumber} from "libphonenumber-js";
const isPhone = helpers.regex(/^[0-9]{8}/); //phone valid
import {mapActions, mapGetters} from "vuex";

const SIZE_IMAGE = 2;
export default {
  name: "AddEleve",
  components: {
    TopTemplate,
    Datepicker,
    "v-select": vSelect,
  },

  data() {
    return {
      errorMessage: false,
      phoneExist: false,
      isSubmitted: false,
      LoadfamilySituation: false,
      loadListYears: false,
      loadListActivities: false,
      loadListServices: false,
      loadingService: false,
      v$: useValidate(),
      studentId: null,
      checked: false,
      dir: "ltr",
      discount_type: [
        {name: "%", id: "1"},
        {name: "DT", id: "2"},
      ],
      gender: [
        {name: "Garçon", id: 0},
        {name: "Fille", id: 1},
      ],
      student: new Form({
        first_name: "",
        last_name: "",
        phone_number: null,
        email: null,
        birthday: "",
        place_of_birth: "",
        photo: "",
        level_id: null,
        class_school_id: null,
        class_type_id: null,
        student_situation_id: "",
        parent_situation_id: "",
        parent_id: "",
        student_gender: null,
        compoFiled: "",
        user_id: null,
        id: "",
        parents: [
          {
            first_name: null,
            last_name: null,
            email: null,
            phone: null,
            function: null,
            gender: null,
            lieu_travail: null,
            relation_eleve: null,
            ville: null,
            pays: null,
            code_postale: null,
            addresse: null,
          },
          {
            first_name: null,
            last_name: null,
            email: null,
            phone: null,
            function: null,
            gender: null,
            lieu_travail: null,
            relation_eleve: null,
            ville: null,
            pays: null,
            code_postale: null,
            addresse: null,
          },
        ],
        parents_tuteur: [
          {
            first_name: "",
            last_name: "",
            email: "",
            relation_eleve: "",
            addresse: "",
            ville: "",
            code_postale: "",
            pays: "",
            phone: "",
          },
        ],

        scolarities: [
          {
            school_year: null,
            school_name: "",
            class_type_id: null,
            class_type: null,
          },
        ],
        activities: [
          {
            activity_id: null,
            description: "",
          },
        ],
        services: [
          {
            service_id: null,
            discount_type: "1",
            discount_value: 0,
            error: false,
            errorPercent: false,
            errorNumber: false,
            maxAmount: null,
          },
        ],
      }),
      loading: false,
      levels: [],
      classes: [],
      errorDocSize: false,
      otherparent: [],
      school_year: null,
      years: [],
      disabled: true,
      activities: [],
      services: [],
      studentSituation: [],
      parentSituation: [],
      status: 0,
      isValidate: false,
      show1: true,
      show2: true,
      show3: false,
      show4: false,
      show5: false,
      show6: false,
      show7: false,
      showcompo: false,
      loaderPere: false,
      loaderPerePhone: false,
      loaderTuteur: false,
      loaderTuteurPhone: false,
      existPay: false,
      loaderMere: false,
      loaderMerePhone: false,
      showerremailpere: false,
      showerremailmere: false,
      tuteurAdd: false,
      completeAdresseMother: false,
      is_created: false,
      selectedSituation: [],
      completeAdresseTuteur: false,
      allService: null,
      existStudent: false,
      validNumbers: [
        {valid: true, unique: true},
        {valid: true, unique: true},
        {valid: true, unique: true},
        {valid: true, unique: true},
      ],
      isRequiredPhone: [
        {valid: true, required: true},
        {valid: true, required: true},
        {valid: true, required: true},
        {valid: true, required: true},
      ],
    };
  },
  validations() {
    return {
      student: {
        first_name: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        level_id: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        last_name: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        parents: [
          {
            phone: {
              required: helpers.withMessage(
                this.$t("validation.required"),
                requiredIf(
                  this.student.parents[0].first_name ||
                    this.student.parents[0].last_name ||
                    this.student.parents[0].email ||
                    this.student.parents[0].function ||
                    this.student.parents[0].lieu_travail
                )
              ),
            },

            email: {
              email: helpers.withMessage(this.$t("validation.email"), email),
            },
            code_postale: {
              numeric: helpers.withMessage(this.$t("validation.numeric"), numeric),
            },
          },
          {
            email: {
              email: helpers.withMessage(this.$t("validation.email"), email),
            },
            code_postale: {
              numeric: helpers.withMessage(this.$t("validation.numeric"), numeric),
            },
            phone: {
              required: helpers.withMessage(
                this.$t("validation.required"),
                requiredIf(
                  this.student.parents[1].first_name ||
                    this.student.parents[1].last_name ||
                    this.student.parents[1].email ||
                    this.student.parents[1].function ||
                    this.student.parents[1].lieu_travail ||
                    this.student.parents[1].addresse ||
                    this.student.parents[1].ville ||
                    this.student.parents[1].pays ||
                    this.student.parents[1].code_postale
                )
              ),
            },
          },
        ],
        parents_tuteur: [
          {
            phone: {
              required: helpers.withMessage(
                this.$t("validation.required"),
                requiredIf(() => {
                  if (this.student.parents_tuteur[0]) {
                    return (
                      this.student.parents_tuteur[0].first_name ||
                      this.student.parents_tuteur[0].last_name ||
                      this.student.parents_tuteur[0].email ||
                      this.student.parents_tuteur[0].relation_eleve ||
                      this.student.parents_tuteur[0].addresse ||
                      this.student.parents_tuteur[0].ville ||
                      this.student.parents_tuteur[0].code_postale ||
                      this.student.parents_tuteur[0].pays
                    );
                  }
                  return false;
                })
              ),
            },

            email: {
              email: helpers.withMessage(this.$t("validation.email"), email),
            },
            code_postale: {
              numeric: helpers.withMessage(this.$t("validation.numeric"), numeric),
            },
          },
        ],
        scolarities: {
          $each: helpers.forEach({
            class_type_id: {
              required: helpers.withMessage(this.$t("validation.required"), required),
            },
            school_year: {
              required: helpers.withMessage(this.$t("validation.required"), required),
            },
          }),
        },
      },
    };
  },
  computed: {
    ...mapGetters(["getScolarityFilter"]),
    maxDate() {
      return moment().utc().format("YYYY-MM-DD");
    },
    computedScolarityYear() {
      return (year) => {
        if (this.student.scolarities.length === 1 && !this.student.scolarities[0].school_year) {
          return this.getScolarityFilter.school_year;
        }
        const existingIds = this.student.scolarities.reduce((ids, scolarity) => {
          const {school_year} = scolarity;
          if (school_year) ids.add(school_year);
          return ids;
        }, new Set());

        const filteredSchoolYears = this.getScolarityFilter.school_year.filter((item) => !existingIds.has(item.id) || item.id === year);
        return filteredSchoolYears;
      };
    },
    computedOptionsTypes() {
      return (school_year) => {
        const types = this.getScolarityFilter.school_year.find((item) => item.id === school_year)?.types;
        return types || [];
      };
    },
    computedOptionsScolarity() {
      return (school_year, class_type_id) => {
        const types = this.getScolarityFilter.school_year.find((item) => item.id === school_year)?.types;
        return types ? types?.find((type) => type.id === class_type_id)?.classes : [];
      };
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    allSersices() {
      return JSON.parse(localStorage.getItem("services"));
    },
    userModules() {
      return this.$store.state?.auth?.user?.modules;
    },
    validNumbersFather() {
      return this.validNumbers[1];
    },
    validNumbersMother() {
      return this.validNumbers[0];
    },
    validNumbersTuteur() {
      return this.validNumbers[2];
    },
    validNumbersStudent() {
      return this.validNumbers[3];
    },
    requiredNumbersFather() {
      return this.isRequiredPhone[1];
    },
    requiredNumbersMother() {
      return this.isRequiredPhone[0];
    },
    requiredNumbersTuteur() {
      return this.isRequiredPhone[2];
    },
  },
  watch: {
    allSersices(newValue, oldValue) {
      this.allService = newValue;
    },
  },
  created() {
    this.studentId = this.$route.params.id;
  },

  mounted() {
    localStorage.removeItem("services");
    this.getById();
    this.moduleUser();
    this.handleFilterScolarity();
  },
  methods: {
    ...mapActions(["getFilterStudentsScolarity"]),
    async handleFilterScolarity() {
      await this.getFilterStudentsScolarity();
    },
    resetFields(key, index) {
      const scol = this.student.scolarities[index];
      if (key === "school_year") {
        scol.class_type_id = null;
        scol.class_school_id = null;
      } else if (key === "class_type_id") {
        scol.class_school_id = null;
      }
    },
    checkParentPhoneNumbers() {
      if (!this.student.parents[0] || !this.student.parents[1]) {
        this.errorMessage = false;
        return;
      }

      const phone1 = this.student.parents[0]?.phone?.trim() || "";
      const phone2 = this.student.parents[1]?.phone?.trim() || "";
      this.errorMessage = phone1 === phone2;
    },
    checkIfElementNameIsEleves() {
      return this.userModules.some((element) => element.name === "Élèves");
    },
    checkIfElementPayIsEleves() {
      return this.userModules.some((element) => element.name === "Paiements");
    },
    moduleUser() {
      this.existPay = this.checkIfElementPayIsEleves();
      this.existStudent = this.checkIfElementNameIsEleves();
    },
    isRequiredPhones() {
      if ((this.student.parents[0]?.first_name || this.student.parents[0]?.last_name) && !this.student.parents[0]?.phone) {
        this.isRequiredPhone[0].required = false;
      }
      if ((this.student.parents[1]?.first_name || this.student.parents[1]?.last_name) && !this.student.parents[1]?.phone) {
        this.isRequiredPhone[1].required = false;
      }
      if ((this.student.parents_tuteur[0]?.first_name || this.student.parents_tuteur[0]?.last_name) && !this.student.parents_tuteur[0]?.phone) {
        this.isRequiredPhone[2].required;
      }
    },
    isUniquep(value) {
      value = value.replaceAll(/\s/g, "");
      if (value === "" || !value) this.validNumbers[0].unique = true;
      if (value === this.student.parents[1].phone.replaceAll(/\s/g, "") || value === this.student.parents_tuteur[0]?.phone.replaceAll(/\s/g, ""))
        this.validNumbers[0].unique = false;
      else this.validNumbers[0].unique = true;
    },
    isUniquem(value) {
      if (!value) {
        this.validNumbers[1].unique = true;
        return;
      }

      value = value.replaceAll(/\s/g, "");
      if (value === "" || !value) {
        this.validNumbers[1].unique = true;
      } else if (value === this.student.parents[0]?.phone?.replaceAll(/\s/g, "") || value === this.student.parents_tuteur[0]?.phone?.replaceAll(/\s/g, "")) {
        this.validNumbers[1].unique = false;
      } else {
        this.validNumbers[1].unique = true;
      }
    },

    isUniquet(value) {
      value = value.replaceAll(/\s/g, "");
      if (value === "" || !value) this.validNumbers[2].unique = true;
      if (value === this.student.parents[0].phone.replaceAll(/\s/g, "") || value === this.student.parents[1].phone.replaceAll(/\s/g, "")) this.validNumbers[2].unique = false;
      else this.validNumbers[2].unique = true;
    },

    formatPhoneNumber(value, index) {
      if (value.length === 0) {
        this.validNumbers[index].valid = true;
        return;
      }
      let phoneNumber = parsePhoneNumberFromString(value, "TN");
      if (value) {
        if (!phoneNumber) {
          this.validNumbers[index].valid = true;
          return;
        }
        this.validNumbers[index].valid = isValidNumber(phoneNumber.number);
        if (phoneNumber && this.validNumbers[index].valid) {
          if (index === 2) {
            this.isUniquet(phoneNumber.formatNational());
            this.student.parents_tuteur[0].phone = phoneNumber.formatNational();
          } else {
            if (index === 0) {
              this.isUniquep(phoneNumber.formatNational());
            } else {
              if (index === 3) this.student.phone_number = phoneNumber.formatNational();
              else this.isUniquem(phoneNumber.formatNational());
            }
            //this.student.parents[index].phone = phoneNumber.formatNational()
          }
        } else if (phoneNumber.length > 2) {
          if (index === 2) this.student.parents_tuteur[0].phone = value;
          else this.student.parents[index].phone = value;
        }
      }
    },
    preventNegative(event) {
      // Empêcher la saisie du signe moins "-"
      if (event.key === "-") {
        event.preventDefault();
      }
    },
    validateDiscount(event) {
      let price = event.student_service_price_discounted ? event.student_service_price_discounted : event.service.price.price;
      event.maxAmount = price;
      event.error = parseInt(event.discount_type) === 2 && parseFloat(event.discount_value) > price;
      event.errorPercent = parseInt(event.discount_type) === 1 && (parseFloat(event.discount_value) > 100 || parseFloat(event.discount_value) < 0);
      event.errorNumber = isNaN(event.discount_value);
      if (event.errorNumber) {
        event.error = false;
        event.errorPercent = false;
      }
    },
    changetypeDiscount(service) {
      service.discount_value = 0;
      service.error = false;
      service.errorPercent = false;
      service.errorNumber = false;
    },
    format_date_v1(value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY");
      }
    },
    checkParent() {
      this.otherparent = [];
      this.student.parents.map((item, index) => {
        let result = !Object.values(item).every((o) => o === null);
        if (result) {
          index === 0 ? (item.gender = "1") : (item.gender = "0");

          if (item.first_name !== "" && item.last_name !== "" && item.email !== "" && item.phone !== "") {
            this.otherparent.push(item);
          }
        }
      });
    },
    getDataMere() {
      if (this.student.parents[0].email) {
        if (this.student.parents[0].email.length > 2) {
          this.loaderMere = true;
          StudentService.checkParent({
            params: {
              email: this.student.parents[0].email,
              gender: 1,
            },
          })
            .then((data) => {
              this.meredata = data.data.data;
              if (this.meredata != "" && this.meredata != undefined) {
                this.student.parents[0] = this.meredata;

                if (
                  this.student.parents[0].addresse != null ||
                  this.student.parents[0].ville != null ||
                  this.student.parents[0].code_postale != null ||
                  this.student.parents[0].pays != null
                ) {
                  this.completeAdresseMother = true;
                }
              }
              this.loaderMere = false;
            })
            .catch((error) => {});
        }
      }
    },
    getDataPere() {
      if (this.student.parents[1].email && data.gender === 0) {
        if (this.student.parents[1].email.length > 2) {
          this.loaderPere = true;
          StudentService.checkParent({
            params: {
              email: this.student.parents[1].email,
              gender: 0,
            },
          })
            .then((data) => {
              this.peredata = data.data.data;
              if (this.peredata != "" && this.peredata != undefined) this.student.parents[1] = this.peredata;

              this.loaderPere = false;
            })
            .catch((error) => {});
        }
      }
    },
    emailMessage(expr) {
      if (this.student.parents[0].email != "" && this.student.parents[1].email != "") {
        if (this.student.parents[0].email === this.student.parents[1].email) {
          switch (expr) {
            case "emailpere":
              this.showerremailpere = true;
              break;
            case "emailmere":
              this.showerremailmere = true;
              break;
            default:
              this.showerremailpere = false;
              this.showerremailmere = false;
          }
        } else {
          this.showerremailpere = false;
          this.showerremailmere = false;
        }
      }
    },
    ListYears() {
      const curentDate = moment();
      var yearC = curentDate.format("YYYY");
      StudentService.getAllyear({
        params: {},
      })
        .then((response) => {
          this.loadListYears = true;
          this.status = response.data.data;
          this.years = this.status.filter(function (el) {
            let yearCurent = el.school_year.split("/");
            yearCurent = yearCurent[1];
            return yearCurent != yearC;
          });
          this.school_year = this.status.filter(function (el) {
            let yearCurents = el.school_year.split("/");
            yearCurents = yearCurents[1];
            return yearCurents === yearC;
          });
        })
        .finally(() => {
          this.ChangeLevel(this.student.level_id.id, false);
          this.loading = false;
        });
    },
    openChekboxModher() {
      this.student.parents?.forEach((parent) => {
        if (parent.gender != 0) {
          if (parent.pays != null || parent.ville != null || parent.code_postale != null) {
            this.completeAdresseMother = true;
          }
        }
      });
    },

    addTuteur() {
      this.tuteurAdd = !this.tuteurAdd;
      this.student.parents_tuteur.push({
        first_name: "",
        last_name: "",
        email: "",
        relation_eleve: "",
        phone: "",
        ville: null,
        pays: null,
        code_postale: "",
        addresse: "",
      });
    },
    changeLanguage() {
      if (this.checked === true) {
        this.dir = "rtl";
      } else {
        this.dir = "ltr";
      }
    },
    addMore() {
      this.student.scolarities.push({
        school_year: "",
        school_name: this.getScolarityFilter?.school_name,
        class_type_id: null,
        class_school_id: null,
      });
    },

    addMoreEx() {
      this.student.activities.push({
        activity_id: null,
        description: "",
      });
    },
    disabledAdd(service) {
      if (!service) {
        return true; // ou false, selon votre logique
      }

      let id;
      if (!service[service.length - 1].service) {
        id = service[service.length - 1].service_id;
      } else {
        id = service[service.length - 1].service.id;
      }
      return id === null || id === "" || id === undefined;
    },
    disabledamountValue(service, index) {
      let id;
      if (!service[index].service) {
        id = service[index].service_id;
      } else {
        id = service[index].service.id;
      }
      return id === null || id === "" || id === undefined;
    },
    addMoreSer() {
      this.student.services.map((item, idex) => {
        if (item.service_id) {
          const id = item.service_id;
          let idxServ;
          if (this.services.length > 0) {
            idxServ = this.services.findIndex((object) => {
              return object.id === id;
            });
            if (idxServ !== -1) this.services.splice(idxServ, 1);
          }
        } else if (item.service) {
          const id = item.service.id;
          const idxServ = this.services.findIndex((object) => {
            return object.id === id;
          });
          if (idxServ !== -1) this.services.splice(idxServ, 1);
        }
      });

      this.student.services.push({
        service_id: null,
        discount_type: "1",
        discount_value: 0,
      });
    },
    removeItem(i) {
      this.student.scolarities = this.student.scolarities.filter((el, index) => index != i);
    },
    removeItemEx(i) {
      this.student.activities = this.student.activities.filter((el, index) => index != i);
    },
    removeItemSer(services, i) {
      if (services.service) {
        const newservice = this.allService.filter((el, index) => el.id === services.service.id);
        const isexist = this.services.filter((el, index) => el.id === services.service.id);

        if (isexist.length === 0 && newservice[0] != undefined) {
          this.services.push(newservice[0]);
        }
      } else {
        const newservice = this.allService.filter((el, index) => el.id === services.service_id);
        const isexist = this.services.filter((el, index) => el.id === services.service_id);

        if (isexist.length === 0 && newservice[0] != undefined) {
          this.services.push(newservice[0]);
        }
      }
      this.student.services = this.student.services.filter((el, index) => index != i);
    },
    getDataTuteur() {
      if (this.student.parents_tuteur[0].email) {
        if (this.studentparents_tuteur[0].email.length > 2) {
          this.loaderTuteur = true;
          StudentService.checkParent({
            params: {
              email: this.student.parents_tuteur[0].email,
            },
          })
            .then((data) => {
              this.tuteurdata = data.data.data;
              if (this.tuteurdata != "" && this.tuteurdata != undefined) {
                this.student.parents_tuteur[0] = this.tuteurdata;

                if (
                  this.student.parents_tuteur[0].addresse != null ||
                  this.student.parents_tuteur[0].ville != null ||
                  this.student.parents_tuteur[0].code_postale != null ||
                  this.student.parents_tuteur[0].pays != null
                ) {
                  this.completeAdresseTuteur = true;
                }
              }
              this.loaderTuteur = false;
            })
            .catch((error) => {});
        }
      }
    },
    getDataTuteurByPhone() {
      if (this.student.parents_tuteur[0].phone != "") {
        this.loaderTuteurPhone = true;
        StudentService.checkParent({
          params: {
            phone: this.student.parents_tuteur[0].phone.replaceAll(/\s/g, ""),
            gender: 1,
          },
        })
          .then((data) => {
            this.tuteurdata = data.data.data;
            if (this.tuteurdata != "" && this.tuteurdata != undefined) {
              this.student.parents_tuteur[0] = this.tuteurdata;
              if (
                this.student.parents_tuteur[0].addresse != null ||
                this.student.parents_tuteur[0].ville != null ||
                this.student.parents_tuteur[0].code_postale != null ||
                this.student.parents_tuteur[0].pays != null
              ) {
                this.completeAdresseTuteur = true;
              }
            }
            this.loaderTuteurPhone = false;
          })
          .catch((error) => {});
      }
    },
    getDataPereByPhone() {
      if (this.student.parents[1].phone != "") {
        this.loaderPerePhone = true;
        StudentService.checkParent({
          params: {
            phone: this.student.parents[1].phone.replaceAll(/\s/g, ""),
            gender: 0,
          },
        })
          .then((data) => {
            this.peredata = data.data.data;
            if (this.peredata != "" && this.peredata != undefined) this.student.parents[1] = this.peredata;
            this.loaderPerePhone = false;
          })
          .catch((error) => {});
      }
    },
    getDataMereByPhone() {
      if (this.student.parents[0]?.phone) {
        this.loaderPerePhone = true;
        const cleanedPhone = this.student.parents[0].phone.replaceAll(/\s/g, "");
        StudentService.checkParent({
          params: {
            phone: cleanedPhone,
            gender: 1,
          },
        })
          .then((data) => {
            this.meredata = data.data.data;
            if (this.meredata !== "" && this.meredata !== undefined) {
              this.student.parents[0] = this.meredata;
            }
            this.loaderPerePhone = false;
          })
          .catch((error) => {});
      }
    },

    toggleAccInfo() {
      this.show1 = !this.show1;
    },
    toggleAccNiv() {
      this.show2 = !this.show2;
    },
    toggleAccComp() {
      this.showcompo = !this.showcompo;
    },
    toggleAccPar() {
      this.show3 = !this.show3;
    },
    toggleAccSit() {
      if (!this.LoadfamilySituation) {
        this.ListSituationsStudent();
      }
      this.show4 = !this.show4;
    },
    toggleAccSco() {
      if (!this.loadListYears) {
        this.ListYears();
      }
      this.show5 = !this.show5;
    },
    toggleAccEx() {
      if (!this.loadListActivities) {
        this.ListActivities();
      }
      this.show6 = !this.show6;
    },
    toggleAccSer() {
      if (!this.loadListServices) {
        this.ListServices();
      }

      this.show7 = !this.show7;
    },
    getById() {
      this.loading = true;
      StudentService.get(this.studentId)
        .then((response) => {
          let data = response.data.data;
          this.show5 = true;
          this.student.user_id = data.user_id;
          this.student.first_name = data.first_name;
          this.student.last_name = data.last_name;
          this.student.phone_number = data.phone;
          this.student.email = data.email;
          this.student.student_gender = data.student_gender;
          this.student.place_of_birth = data.place_of_birth;
          this.student.id = data.id;
          if (data.birthday != null) {
            this.student.birthday = moment(data.birthday).format("YYYY-MM-DD");
          } else {
            this.student.birthday = null;
          }
          this.student.photo = data?.photo;
          if (data.class_types) {
            this.student.level_id = data.class_types;
          }
          this.student.compoFiled = data.additional_information;
          if (data.class) {
            this.student.class_school_id = data.class;
          }
          this.student.student_situation_id = data.student_situations?.student_situation?.id;
          //this.parentSituation= data.parent_situations;
          this.selectedSituation = [];
          data.parent_situations.forEach((element) => {
            //element.parent_situation===null && this.selectedSituation.push(null)
            element.parent_situation != null && this.selectedSituation.push(element.parent_situation.id);
          });
          if (data.parents.length === 1 && (data.parents[0].first_name || data.parents[0].last_name || data.parents[0].email || data.parents[0].phone)) {
            if (data.parents[0] && data.parents[0].gender === 0) {
              this.student.parents[1] = data.parents[0];
            } else if (data.parents[0].gender === 1) {
              this.student.parents[0] = data.parents[0];
            }
          } else if (data.parents.length > 1) {
            this.student.parents[1] = data.parents[1];
            this.student.parents[0] = data.parents[0];
          }

          if (data.parents_tuteur[0]) {
            this.tuteurAdd = true;
            this.student.parents_tuteur[0] = data.parents_tuteur[0];

            if (this.student.parents_tuteur.length > 0) {
              if (this.student.parents_tuteur[0].pays != null || this.student.parents_tuteur[0].ville != null || this.student.parents_tuteur[0].code_postale != null) {
                this.completeAdresseTuteur = true;
              }
            }
          }
          const scolarities = data.scolarities.map((item) => ({
            school_year: item.school_year?.id || null,
            class_type_id: item.class_type_id || null,
            class_school_id: item.class?.id || null,
            school_name: item.school_name || null,
            id: item.id || null,
          }));
          this.student.scolarities = scolarities;

          if (data.activities.length > 0) {
            this.student.activities = data.activities;
          }
          if (data.services.length > 0) {
            this.student.services = data.services;
          }
          this.classes = this.levels.find((x) => x.id === data.class_types.id)?.classe;
          this.ListLevels();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    ListLevels() {
      LevelsService.getAll({
        params: {},
      }).then(
        (response) => {
          this.levels = response.data.data.filter((lev) => lev.classe != lev.classe.length > 0);
          this.openChekboxModher();

          this.ListYears();
        },
        (error) => {
          console.error(error);
        }
      );
    },
    ListActivities() {
      ActivitiesService.getAll({
        params: {},
      }).then(
        (response) => {
          this.loadListActivities = true;
          this.activities = response.data.data;
        },
        (error) => {}
      );
    },
    ListServices() {
      this.loadingService = true;
      ServicesService.getAll({
        params: {active: 1},
      })
        .then(
          (response) => {
            this.loadListServices = true;
            const allServicet = response.data.data;
            localStorage.setItem("services", JSON.stringify(allServicet));
            this.allService = JSON.parse(localStorage.getItem("services"));
            this.services = response.data.data;
            this.student.services.map((item, idex) => {
              if (item.service_id) {
                const id = Number.isInteger(item.service_id) ? item.service_id : item.service_id.id;
                const idxServ = this.services.findIndex((object) => {
                  return object.id === id;
                });

                if (idxServ !== -1) this.services.splice(idxServ, 1);
              }
            });
          },
          (error) => {
            console.error(error);
          }
        )
        .finally(() => {
          this.loadingService = false;
        });
    },
    ListSituationsStudent() {
      allRequests([SituationsService.getStudentSituation(), SituationsService.getParentSituation()]).then((responses) => {
        this.LoadfamilySituation = true;
        this.studentSituation = responses[0].data.data;
        this.parentSituation = responses[1].data.data;
      });
    },
    updateStudent(id, data) {
      StudentService.update(id, data)
        .then(() => {
          this.is_created = true;
          this.scrollToTop();
          this.$router.push({
            name: "DetailStudent",
            params: {id: id},
          });
        })
        .catch((error) => {
          this.is_created = false;
          if (error.response.data.errors.phone_number) {
            this.phoneExist = true;
          }
          this.scrollToTop();
        })
        .finally(() => {
          this.isSubmitted = false;
          this.loading = false;
        });
    },
    onSubmitCreateStudent() {
      this.isValidate = false;
      //this.isRequiredPhones();
      this.v$.$validate();
      if (this.errorDocSize) {
        this.scrollToTop();
      }
      if (this.errorMessage) {
        this.scrollToTop();
      }
      if (this.v$.student.first_name.$error || this.v$.student.last_name.$error || this.v$.student.level_id.$error) {
        this.show1 = true;

        this.show2 = true;
      }
      if (
        this.v$.student.parents[0].email.$error ||
        this.v$.student.parents[0].code_postale.$error ||
        this.v$.student.parents[1].email.$error ||
        this.v$.student.parents[1].code_postale.$error ||
        this.v$.student.parents_tuteur[0].email.$error ||
        this.v$.student.parents_tuteur[0].code_postale.$error
      ) {
        this.show3 = true;
      }
      this.isSubmitted = true;
      this.loading = true;
      this.$nextTick(() => {
        if (document.querySelector(".is-invalid")) {
          //this.candidature.edit_candidat = true;
          this.show1 = true;
          this.show2 = true;
          this.show3 = true;
          this.show4 = true;
          this.show5 = true;
          this.show6 = true;
          this.show7 = true;
          this.showcompo = true;
          let domRect = document.querySelector(".is-invalid").getBoundingClientRect();
          window.scrollTo({
            left: domRect.left + document.documentElement.scrollLeft,
            top: domRect.top + document.documentElement.scrollTop - 90,
            behavior: "smooth",
          });
        }
      });
      if (
        !this.errorDocSize &&
        !this.v$.$error &&
        //this.validNumbers[0].valid &&
        !this.errorMessage &&
        this.validNumbers[1].valid &&
        this.validNumbers[2].valid &&
        this.validNumbers[2].unique &&
        this.validNumbers[1].unique &&
        this.validNumbers[0].unique &&
        this.isRequiredPhone[1].required &&
        this.isRequiredPhone[0].required &&
        this.isRequiredPhone[2].required
      ) {
        this.loading = true;
        let isValidservice = true;
        this.student.services.map((item, index) => {
          if (item.error || item.errorPercent || item.errorNumber) {
            this.show7 = true;
            isValidservice = false;
          }
          if (!Number.isInteger(item.service_id)) {
            item.service_id = item.service ? item.service.id : null;
          }
          if (!item.service_id && !item.discount_type && !item.discount_value) {
            this.student.services.splice(index, 1);
          }
        });
        if (!isValidservice) {
          this.loading = false;
          return;
        }
        this.checkParent();
        let classType = !Number.isInteger(this.student.level_id) ? this.student.level_id.id : this.student.level_id;
        let classSchole;
        if (this.student.class_school_id) {
          classSchole = !Number.isInteger(this.student.class_school_id) ? this.student.class_school_id.id : this.student.class_school_id;
        }
        this.student.activities.map((item, index) => {
          if (!Number.isInteger(item.activity_id)) {
            item.activity_id = item.activity ? item.activity.id : null;
          }
          if (!item.activity_id && (!item.description || item.description === "")) {
            this.student.activities.splice(index, 1);
          }
        });
        if (this.otherparent.length > 1) {
          if (
            this.otherparent[0].gender === "1" &&
            (this.otherparent[0].first_name === "" || !this.otherparent[0].first_name) &&
            (this.otherparent[0].last_name === "" || !this.otherparent[0].last_name) &&
            (this.otherparent[0].email === "" || !this.otherparent[0].email) &&
            (this.otherparent[0].phone === "" || !this.otherparent[0].phone)
          ) {
            this.otherparent[0] = [];
          }
          if (
            this.otherparent[1].gender === "0" &&
            (this.otherparent[1].first_name === "" || !this.otherparent[1].first_name) &&
            (this.otherparent[1].last_name === "" || !this.otherparent[1].last_name) &&
            (this.otherparent[1].email === "" || !this.otherparent[1].email) &&
            (this.otherparent[1].phone === "" || !this.otherparent[1].phone)
          ) {
            this.otherparent[1] = [];
          }
        } else {
          if (this.otherparent.length === 1) {
            if (
              (this.otherparent[0].gender === "1" || this.otherparent[0].gender === "0") &&
              (this.otherparent[0].first_name === "" || !this.otherparent[0].first_name) &&
              (this.otherparent[0].last_name === "" || !this.otherparent[0].last_name) &&
              (this.otherparent[0].email === "" || !this.otherparent[0].email) &&
              (this.otherparent[0].phone === "" || !this.otherparent[0].phone)
            ) {
              this.otherparent = [];
            }
          }
        }

        if (this.student.parents_tuteur.length === 1) {
          if (
            (this.student.parents_tuteur[0].first_name === "" || !this.student.parents_tuteur[0].first_name) &&
            (this.student.parents_tuteur[0].last_name === "" || !this.student.parents_tuteur[0].last_name) &&
            (this.student.parents_tuteur[0].email === "" || !this.student.parents_tuteur[0].last_name) &&
            (this.student.parents_tuteur[0].phone === "" || !this.student.parents_tuteur[0].phone)
          ) {
            this.student.parents_tuteur = [];
          }
        }
        const promises = this.student.parents_tuteur.map((item, index) => {
          let result = !Object.values(item).every((o) => o === null);
          if (!result) {
            this.student.parents_tuteur.splice(index, 1);
            if (this.student.parents_tuteur.length === 0) {
              this.tuteurAdd = false;
            }
          }
        });
        if (this.otherparent.length > 1) {
          if (this.otherparent[0]?.phone?.length > 2) {
            this.otherparent[0].phone = this.otherparent[0].phone.replaceAll(" ", "");
          }
          if (this.otherparent[1]?.phone?.length > 2) {
            this.otherparent[1].phone = this.otherparent[1].phone.replaceAll(" ", "");
          }
        } else if (this.otherparent.length === 1) {
          if (this.otherparent[0]?.phone?.length > 2) {
            this.otherparent[0].phone = this.otherparent[0].phone.replaceAll(" ", "");
          }
        }
        if (this.student.parents_tuteur[0]?.phone?.length > 2) {
          this.student.parents_tuteur[0].phone = this.student.parents_tuteur[0].phone.replaceAll(/\s/g, "");
        }

        Promise.all(promises).then(() => {
          const data = {
            user_id: this.student.user_id,
            first_name: this.student.first_name,
            last_name: this.student.last_name,
            student_gender: this.student.student_gender,
            birthday: this.student.birthday,
            place_of_birth: this.student.place_of_birth,
            photo: this.student.photo,
            phone_number: this.existStudent ? (this.student.phone_number ? this.student.phone_number.replaceAll(/\s/g, "") : null) : null,
            email: this.existStudent ? this.student.email : null,
            class_type_id: classType,
            class_school_id: classSchole,
            parents: this.otherparent,
            parents_tuteur: this.student.parents_tuteur,
            student_situation_id: this.student.student_situation_id,
            parent_situation_ids: JSON.parse(JSON.stringify(this.selectedSituation)),
            scolarities: this.student.scolarities,
            activities: this.student.activities,
            services: this.student.services,
            additional_information: this.student.compoFiled,
          };
          this.updateStudent(this.studentId, data);
        });
      } else {
        this.loading = false;
        this.is_created = false;
      }
    },
    loadListLevel() {
      if (this.levels.length === 0) {
        this.ListLevels();
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    ChangeLevel(value, emptySelect) {
      this.classes = [];
      if (emptySelect) {
        this.student.class_school_id = null;
      }
      if (value != null) {
        if (Number.isInteger(value)) {
          this.classes = this.levels.find((x) => x.id === value)?.classe;
        } else {
          this.classes = this.levels.find((x) => x.name === value)?.classe;
        }
        this.show5 = true;

        this.student.scolarities[0].school_name = this.currentUser.school_name;
        this.student.scolarities[0].class_type = this.levels.find((x) => x.id === value);
      } else {
        this.classes = [];
      }
    },
    ChangeDis() {
      this.disabled = false;
    },
    checkFilesSize: _.throttle(function (file) {
      if (!file) {
        this.errorDocSize = false;
      }
      this.errorDocSize = file.size / 1024 / 1024 > SIZE_IMAGE;
    }, 300),
    onImageChange: function (e) {
      let file = e.target.files[0];
      let reader = new FileReader();
      reader.onloadend = (file) => {
        const files = e.target.files[0];
        this.checkFilesSize(files);
        this.student.photo = reader.result;
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>

<style>
.disabled {
  color: gray;
  pointer-events: none !important;
  cursor: no-drop !important;
}
.invalid-phone {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}
</style>
